export default {
  "navInfo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ナビゲーションバーデータ"])},
  "topNav": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["トップナビゲーションバー設定"])}
}